import { c as _c } from "react/compiler-runtime";
import { HEX_ALPHA } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { UtilsTypes } from "@stellar/utils";

/** Same colours as the status chip of the members table */
const STATUS_COLORS = {
  [UtilsTypes.MemberStatus.active]: "primary",
  [UtilsTypes.MemberStatus.pending]: "warning"
};
/** A dot in the colour of the member status, styled like the annotation status icon */
export function MemberStatusIcon(t0) {
  const $ = _c(9);
  const {
    status
  } = t0;
  const color = STATUS_COLORS[status];
  let t1;
  if ($[0] !== color) {
    t1 = function withOpacity(theme, opacity) {
      return `rgb(${theme.vars?.palette[color].mainChannel} / ${opacity})`;
    };
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const withOpacity = t1;
  let t2;
  if ($[2] !== withOpacity) {
    t2 = {
      height: "24px",
      width: "24px",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border: theme_0 => `1px solid ${withOpacity(theme_0, HEX_ALPHA.alpha80)}`,
      backgroundColor: theme_1 => withOpacity(theme_1, HEX_ALPHA.alpha1F)
    };
    $[2] = withOpacity;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${color}.main`;
  let t4;
  if ($[4] !== t3) {
    t4 = <Box sx={{
      width: "0.5rem",
      height: "0.5rem",
      borderRadius: "0.25rem",
      backgroundColor: t3
    }} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <Box sx={t2}>{t4}</Box>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}